module.exports = __webpack_public_path__ + "static/media/help.c7ef9a86.svg";